<template>
  <div class="pay-info">
    <a-form :label-col="{ span: 3 }" :wrapper-col="{ span: 12 }" @submit="handleSubmit">
      <a-form-item label="当前余额：">
        <span style="font-size: 15px;font-weight: bold;color: black">{{ balance }}元</span>
      </a-form-item>
      <a-form-item label="请选择充值金额：">
        <!--        <a-input-number :default-value="payInfo.amount" v-model="payInfo.amount"/>-->
        <span :class="nowClass==1?'money_click':'money'" @click="czje(1)">50</span>
        <span :class="nowClass==2?'money_click':'money'" @click="czje(2)">100</span>
        <span :class="nowClass==3?'money_click':'money'" @click="czje(3)">200</span>
        <span :class="nowClass==4?'money_click':'money'" @click="czje(4)">500</span>
        <span :class="nowClass==5?'money_click':'money'" @click="czje(5)">1000</span>
      </a-form-item>
      <a-form-item label="请选择支付方式：">
        <a-radio-group v-decorator="['radio-group']">
          <a-radio value="0" @click="onSubmit">
            <img :src="images.zfb"/>
          </a-radio>
          <a-radio value="1" @click="onSubmit">
            <img :src="images.wx"/>
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="应付金额：">
        <span style="font-weight: bold">{{this.payInfo.amount}}元</span>
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 12, offset: 3}">
        <a-button style="font-size: 15px;width: 150px" type="primary" html-type="submit">
          确认支付
        </a-button>
      </a-form-item>
    </a-form>
    <pay-order @close="modalFormOk" ref="order" :modalData="modalData" :amount="payInfo.amount"></pay-order>
  </div>
</template>

<script>
import PayOrder from "@/views/pay/PayOrder";
import {getAction, postAction} from "@/api/manage";

export default {
  name: "Pay",
  components: {
    PayOrder
  },
  data() {
    return {
      payInfo: {
        amount: 50,
        type: -1
      },
      images: {
        zfb: require("@/assets/zhifubao-normal.png"),
        wx: require("@/assets/weixin-normal.png")
      },
      modalData: {},
      balance: '',
      url: {
        createOrderUrl: '/pay/createOrder',
        getBalanceUrl: '/pay/balance'
      },
      nowClass: 1
    }
  },
  created() {
    this.getBalance();
  },
  methods: {
    czje(e) {
      this.nowClass = e;
      switch (e) {
        case 1:
          this.payInfo.amount = 50;
          break;
        case 2:
          this.payInfo.amount = 100;
          break;
        case 3:
          this.payInfo.amount = 200;
          break;
        case 4:
          this.payInfo.amount = 500;
          break;
        case 5:
          this.payInfo.amount = 1000;
          break;
      }

    },
    modalFormOk() {
      this.getBalance();
      if (this.$route.params.queryType == 0 || this.$route.params.queryType == 1) {
        let param = {
          name: this.$route.params.name,
          entName: this.$route.params.entName,
          idCard: this.$route.params.idCard,
          overdueDate:this.$route.params.overdueDate,
          defaultAmount: this.$route.params.defaultAmount,
          city: this.$route.params.city,
          hasCollateral: this.$route.params.hasCollateral,
          industry:this.$route.params.industry,
          queryType: this.$route.params.queryType
        }
        this.$router.push({name: 'report', params: param});
      } else {
        this.$router.push({name: 'pay'});
      }
    },
    handleSubmit(e){
      if(this.payInfo.type===-1){
        this.$message.error('请选择支付方式');
        return ;
      }
      this.$refs.order.visible = true;
      postAction(this.url.createOrderUrl, this.payInfo).then((res) => {
        if (res.success) {
          this.modalData = res.data;
          this.modalData.type = this.payInfo.type;
          this.modalData.amount = this.payInfo.amount;
          this.modalData.qrCode = "data:image/jpeg;base64," + this.modalData.qrCode;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    onSubmit(e) {
      // if (this.payInfo.amount <= 0) {
      //   this.$message.error('单次充值最小额度为100元');
      //   return;
      // }
      switch (e.target.value) {
        case "0":
          this.images.zfb = require("@/assets/zhifubao-checked.png"), this.images.wx = require("@/assets/weixin-normal.png");
          break;
        case "1":
          this.images.zfb = require("@/assets/zhifubao-normal.png"), this.images.wx = require("@/assets/weixin-checked.png");
          break;
      }
      this.payInfo.type = e.target.value;
    },
    getBalance() {
      getAction(this.url.getBalanceUrl).then(res => {
        if (res.success) {
          this.balance = res.data.balance;
        }
      })
    }
  }
}
</script>

<style scoped>
.pay-info {
  width: 1200px;
  margin: 20px auto;
  background: #FFFFFF;
  min-height: calc(100vh - 240px);
  padding: 30px;
}

.money {
  padding: 10px 30px;
  border: 1px solid dodgerblue;
  border-radius: 8px;
  margin-right: 20px;
  cursor: pointer;
  color: dodgerblue;
}

.money_click {
  padding: 10px 30px;
  border: 1px solid dodgerblue;
  border-radius: 8px;
  margin-right: 20px;
  cursor: pointer;
  background-color: dodgerblue;
  color: white;
}
</style>
